import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-record-page-transfer',
  templateUrl: './record-page-transfer.component.html',
  styleUrls: ['./record-page-transfer.component.scss']
})
export class RecordPageTransferComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
